Eshop.confirm = function(text, options, callback) {
    var settings = $.extend({
        title: text,
        text: "",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: 'Zrušiť',
        confirmButtonColor: "#de250e",
        confirmButtonText: "Ok",
        closeOnConfirm: true
    }, options);

    swal(settings, callback);
}